// dependencies
import React, { memo, ReactElement } from "react";
import { isPopFlow, isToingFlow } from "@swiggy-private/checkout-core";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import {
    POP_CROSS_SELL_ICON,
    POP_CROSS_SELL_ICON_DIMENSIONS,
    TOING_CROSS_SELL_ICON,
    TOING_CROSS_SELL_ICON_DIMENSIONS,
} from "@cart-ui/constants";

function CrossSellM2AddItem(): ReactElement {
    if (isPopFlow()) {
        return (
            <Image
                cloudinaryId={POP_CROSS_SELL_ICON}
                width={POP_CROSS_SELL_ICON_DIMENSIONS.WIDTH}
                height={POP_CROSS_SELL_ICON_DIMENSIONS.HEIGHT}
            />
        );
    } else if (isToingFlow()) {
        return (
            <Image
                cloudinaryId={TOING_CROSS_SELL_ICON}
                width={TOING_CROSS_SELL_ICON_DIMENSIONS.WIDTH}
                height={TOING_CROSS_SELL_ICON_DIMENSIONS.HEIGHT}
            />
        );
    }
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="7" fill="white" />
            <rect x="0.5" y="0.5" width="23" height="23" rx="6.5" stroke="#02060C" strokeOpacity="0.15" />
            <path d="M13.25 7H10.75V10.75H7V13.25H10.75V17H13.25V13.25H17V10.75H13.25V7Z" fill="#1BA672" />
        </svg>
    );
}

export default memo(CrossSellM2AddItem);
